export default function(timeData,format) {
    var date = {
        "M+": timeData.getMonth() + 1,
        "D+": timeData.getDate(),
        "h+": timeData.getHours(),
        "m+": timeData.getMinutes(),
        "s+": timeData.getSeconds(),
        "q+": Math.floor((timeData.getMonth() + 3) / 3),
        "S+": timeData.getMilliseconds()
    };
    if (/(y+)/i.test(format)) {
        format = format.replace(RegExp.$1, (timeData.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (var k in date) {
        if (new RegExp("(" + k + ")").test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length == 1
                ? date[k] : ("00" + date[k]).substr(("" + date[k]).length));
        }
    }
    return format;
}